export const generateFileHash = async (file) => {
  // Convert the file to an ArrayBuffer
  const arrayBuffer = await file.arrayBuffer();
  // Compute a SHA-256 hash
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", arrayBuffer);
  // If you want a hex string, convert the hash buffer:
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
};